import { createApiClient } from "@nudgebox/api-client";

/** Same-origin API client: `/v1/*` is served by the API Worker behind this origin. */
export const api = createApiClient();
